// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__19YFP","title":"AfterBackImages_title__3d8xm","images":"AfterBackImages_images__cBFSg"};